import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles((theme: any) => ({
  fieldsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "20px 0"
  },
  fieldStyle: {
    width: "100%",
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px"
  },
  sharedButtonStyle: {
    width: "120px",
    height: "40px",
    borderRadius: "4px",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: 500,
    textTransform: "none",
  },
  submitButton: {
    background: theme.gradiants.button,
    color: "#fdfdfe",
  }
}));

export default useStyles;
